
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 0C11.3806 0 11.7282 0.215867 11.8967 0.556846L14.7543 6.34043L21.1446 7.27358C21.5212 7.32857 21.8338 7.59233 21.9512 7.95399C22.0686 8.31565 21.9703 8.71253 21.6977 8.97781L17.0745 13.4765L18.1656 19.8321C18.2299 20.2069 18.0757 20.5857 17.7677 20.8092C17.4597 21.0327 17.0514 21.0622 16.7145 20.8852L11 17.8828L5.28547 20.8852C4.94855 21.0622 4.54026 21.0327 4.23228 20.8092C3.92431 20.5857 3.77006 20.2069 3.83441 19.8321L4.92549 13.4765L0.302296 8.97781C0.0296781 8.71253 -0.0685944 8.31565 0.048783 7.95399C0.16616 7.59233 0.47884 7.32857 0.855399 7.27358L7.24575 6.34043L10.1033 0.556846C10.2718 0.215867 10.6194 0 11 0ZM11 3.25615L8.80671 7.69529C8.66117 7.98986 8.37999 8.19413 8.05464 8.24163L3.14843 8.95807L6.69774 12.4118C6.93362 12.6413 7.04128 12.9722 6.98562 13.2964L6.14819 18.1744L10.5345 15.8698C10.8259 15.7167 11.1741 15.7167 11.4654 15.8698L15.8518 18.1744L15.0144 13.2964C14.9587 12.9722 15.0664 12.6413 15.3023 12.4118L18.8516 8.95807L13.9454 8.24163C13.62 8.19413 13.3388 7.98986 13.1933 7.69529L11 3.25615Z","fill":"#D9DDE4"}})])
          )
        }
      }
    